module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<p>\n  Bonjour,\n  <br />\n  Une demande de support a été envoyée, ci-dessous le formulaire.\n</p>\n<p>\n")
    ;  if (errorCode) { 
    ; __append("    <strong>Code d’erreur :</strong> ")
    ; __append(escapeFn( errorCode ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (encounteredProblem) { 
    ; __append("    <strong>Problème rencontré :</strong> ")
    ; __append(escapeFn( encounteredProblem ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (identityProvider) { 
    ; __append("    <strong>Compte utilisé :</strong> ")
    ; __append(escapeFn( identityProvider ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (serviceProvider) { 
    ; __append("    <strong>Site accédé :</strong> ")
    ; __append(escapeFn( serviceProvider ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (lastName) { 
    ; __append("    <strong>Nom :</strong> ")
    ; __append(escapeFn( lastName ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (firstName) { 
    ; __append("    <strong>Prénom :</strong> ")
    ; __append(escapeFn( firstName ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (birthdate) { 
    ; __append("    <strong>Date de naissance :</strong> ")
    ; __append(escapeFn( birthdate ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (birthcountry) { 
    ; __append("    <strong>Pays de naissance :</strong> ")
    ; __append(escapeFn( birthcountry ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (birthplace) { 
    ; __append("    <strong>Ville de naissance :</strong> ")
    ; __append(escapeFn( birthplace ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (email) { 
    ; __append("    <strong>Email :</strong> ")
    ; __append(escapeFn( email ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (hasSocialSecurity) { 
    ; __append("    <strong>Numéro de Sécurité Sociale :</strong> ")
    ; __append(escapeFn( hasSocialSecurity ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (phone) { 
    ; __append("    <strong>Numéro de téléphone :</strong> ")
    ; __append(escapeFn( phone ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (errorId) { 
    ; __append("    <strong>Identifiant unique d’erreur :</strong> ")
    ; __append(escapeFn( errorId ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (tags) { 
    ; __append("    <strong>Tag :</strong> ")
    ; __append(escapeFn( tags ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (fraudSurveyOrigin) { 
    ; __append("    <strong>Provenance questionnaire usurpation :</strong> ")
    ; __append(escapeFn( fraudSurveyOrigin ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (sessionId) { 
    ; __append("    <strong>Code d’identification de session :</strong> ")
    ; __append(escapeFn( sessionId ))
    ; __append("<br/>\n")
    ;  } 
    ;  if (description) { 
    ; __append("    <strong>Description :</strong> ")
    ; __append(escapeFn( description ))
    ; __append("<br/>\n")
    ;  } 
    ; __append("</p>\n")
  }
  return __output;

}